<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="1" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">学业信息管理</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi">学业信息管理</div>
    </div>
    <div style="display:flex;">
      <Header :activeIndex="1" class="head01" v-if="!isMobile" />
      <div class="pailie">
        <div class="neirong">
          <div class="head02">
            <div class="jianju">
              <span class="span1">*入学时间</span><el-date-picker v-model="ruxueshijian" type="date" placeholder="入学时间"
                format="yyyy-MM-dd" class="kuandu" value-format="yyyy-MM-dd" :disabled="isDisabled"></el-date-picker>
              <span class="span2">*毕业时间</span><el-date-picker v-model="biyeshijian" type="date" placeholder="毕业时间"
                format="yyyy-MM-dd" class="kuandu" value-format="yyyy-MM-dd" :disabled="isDisabled"></el-date-picker>
            </div>
            <div class="jianju">
              <span class="span1">*毕业院校</span><el-select v-model="yuanxiao" filterable placeholder="请选择" class="kuandu"
                :disabled="isDisabled">
                <el-option v-for="item in yuanxiaos" :key="item.yuanxiao" :label="item.label" :value="item.yuanxiao">
                </el-option>
              </el-select>
              <span class="span2">*学历</span><el-select class="kuandu" v-model="xueli" placeholder="学历"
                :disabled="isDisabled">
                <el-option v-for="item in xuelis" :key="item.xueli" :label="item.label" :value="item.xueli">
                </el-option>
              </el-select>
            </div>
            <div class="jianju">
              <span class="span1">*专业</span><el-cascader v-model="zhuanye" placeholder="请选择专业" :options="zhuanyes"
                @change="handleChange" :props="{ emitPath: false }" filterable class="kuandu" :disabled="isDisabled">
              </el-cascader>

              <span class="span2">学业成绩排名</span><el-select class="kuandu" v-model="xueye" placeholder="学业成绩排名"
                :disabled="isDisabled">
                <el-option v-for="item in xueyes" :key="item.xueye" :label="item.label" :value="item.xueye">
                </el-option>
              </el-select>
            </div>
            <div class="jianju">
              <span class="span1">学业成绩</span>
              <div class="chengjitable">
                <button @click="addRow" :disabled="isDisabled">+</button>
                <button @click="removeRow" :disabled="isDisabled">-</button>
                <table border="1">
                  <thead>
                    <tr>
                      <th>科目</th>
                      <th>成绩</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                      <td><input v-model="row.subject" :disabled="isDisabled" placeholder="请输入科目" /></td>
                      <td><input v-model="row.score" :disabled="isDisabled" type="number" placeholder="请输入成绩" /></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="jianju">
              <div class="liebiao">
                <span class="span1">证书、职称、奖励</span>
                <div style="display:flex;flex-direction: column;">
                  <div v-for="(item, index) in zhengshuList" :key="index" class="input-group">
                    <el-input v-model="zhengshuList[index]" placeholder="请输入证书、职称或奖励" :disabled="isDisabled"
                      class="kuandu" style="margin-right: 10px;"></el-input>
                    <el-button v-if="!isDisabled && zhengshuList.length > 1" type="danger" icon="el-icon-delete" circle
                      @click="removeInput(index)" class="delete-btn"></el-button>
                    <el-button v-if="!isDisabled && index === zhengshuList.length - 1" type="primary" @click="addInput"
                      class="add-btn" icon="el-icon-plus">
                      添加
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="jianju">
              <span class="span1">工作地点偏好</span><el-cascader v-model="loveaddress" :options="rcdistrict" class="kuandu"
                :disabled="isDisabled" @change="handleChangerc" :props="{ checkStrictly: true }"></el-cascader>
            </div>
            <div class="jianju">
              <div class="liebiao">
                <span class="span1">实习</span>
                <div style="display:flex;flex-direction: column;">
                  <div v-for="(item, index) in shixi" :key="index" class="input-group">
                    <el-input v-model="shixi[index]" placeholder="校内外项目/实习/工作经验" :disabled="isDisabled" class="gongzuoexp"
                      type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"></el-input>
                    <el-button v-if="!isDisabled && shixi.length > 1" type="danger" icon="el-icon-delete" circle
                      @click="removeTextarea(index)" class="delete-btn"></el-button>
                    <el-button v-if="!isDisabled && index === shixi.length - 1" type="primary" @click="addTextarea"
                      class="add-btn" icon="el-icon-plus">
                      添加
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class=jianju>
              <div class="baocun" v-if="!isDisabled">
                <div class="save" @click="save">保存信息</div>
              </div>
            </div>
          </div>
        </div>
        <div class="xiugai" v-if="isDisabled">
          <div class="qvxiao" @click="update">修改</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header.vue';
import Footer from './Footer.vue'
export default {
  name: 'personalInf',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      yuanxiaos: [{
        yuanxiao: '选项1',
        label: '清华'
      }, {
        yuanxiao: '选项2',
        label: '北大'
      }, {
        yuanxiao: '选项3',
        label: '人民大学'
      }, {
        yuanxiao: '选项4',
        label: '理工大学'
      }],
      yuanxiao: '',
      value: '',
      ruxueshijian: '',
      biyeshijian: '',
      xuelis: [{
        xueli: '中专',
        label: '中专'
      }, {
        xueli: '专科',
        label: '专科'
      }, {
        xueli: '本科',
        label: '本科'
      }, {
        xueli: '硕士',
        label: '硕士'
      }, {
        xueli: '博士',
        label: '博士'
      }],
      xueli: '',
      zhuanyes: [],
      zhuanye: '',
      xueyes: [{
        xueye: '1',
        label: '10%以内'
      }, {
        xueye: '2',
        label: '30%以内'
      }, {
        xueye: '3',
        label: '50%以内'
      }, {
        xueye: '4',
        label: '50%以下'
      }],
      xueye: '',
      zhengshu: '',
      loveaddress: '',
      rows: [
        { subject: '', score: '' },
        { subject: '', score: '' },
        { subject: '', score: '' }
      ],
      shixi: [""],
      BASE_URL: 'https://zhiyedashi.com/school',
      BASE_URL1: 'https://zhiyedashi.com/info',
      BASE_URL2: 'https://zhiyedashi.com/career',
      // BASE_URL: 'http://192.168.2.8:8205',
      // BASE_URL1: 'http://192.168.2.8:8206',
      // BASE_URL2: 'http://192.168.2.8:8203',
      userId: sessionStorage.getItem("userId"),
      id: null,
      isDisabled: false,
      zhuanyedaima: '',
      rcdistrict: JSON.parse(localStorage.getItem("rc")),
      zhengshuList: [""],
      isMobile: false
    }
  },
  created() {
    // 1. 判断关键数据是否存在
    if (!this.userId) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.selectSchool();
    this.selectResumes()
    this.selectzhuanye()
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    addInput() {
      this.zhengshuList.push("");
    },
    addTextarea() {
      this.shixi.push("")
    },
    removeInput(index) {
      this.zhengshuList.splice(index, 1);
    },
    removeTextarea(index) {
      this.shixi.splice(index, 1);
    },
    handleChangerc(selectedData) {
      const lastNode = selectedData[selectedData.length - 1];

      if (!lastNode.children || lastNode.children.length === 0) {
        this.loveaddress = lastNode
      }
    },
    subject() {
      fetch(`${this.BASE_URL}/admin/major/selectByclass`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `major=${this.zhuanyedaima}`
      })
        .then(res => res.json())
        .then(data => {
          this.rows = JSON.parse(data.data)
        })
        .catch(error => {
          console.error("查询失败1，原因是", error);
        });
    },
    selectzhuanye() {
      if (localStorage.getItem("zhuanyes")) {
        this.zhuanyes = JSON.parse(localStorage.getItem("zhuanyes"))
        this.zhuanyes.forEach(category => {
          category.children.forEach(major => {
            if (major.label === this.zhuanye) {
              this.zhuanye = major.value; // 单选模式直接赋值
            }
          });
        });
      } else {
        fetch(`${this.BASE_URL}/admin/api/majors`)
          .then(res => res.json())
          .then(data => {
            this.zhuanyes = data.data
            localStorage.setItem("zhuanyes", JSON.stringify(data.data))
            this.zhuanyes.forEach(category => {
              category.children.forEach(major => {
                if (major.label === this.zhuanye) {
                  this.zhuanye = major.value; // 单选模式直接赋值
                }
              });
            });
          })
          .catch(error => {
            console.error("查询失败1，原因是", error);
          });
      }
    },
    update() {
      this.isDisabled = false
    },
    save() {
      if (!this.isDisabled) {
        if (this.ruxueshijian === '' || this.biyeshijian === '' || this.yuanxiao === '' || this.xueli === '') {
          alert("入学时间，毕业时间，毕业院校，学历，专业不可为空~")
        } else {
          let chengji = JSON.stringify(this.rows);
          let resumes = {
            id: this.id,
            userId: this.userId,
            admissionDate: this.ruxueshijian,
            graduationDate: this.biyeshijian,
            almaMater: this.yuanxiao,
            degree: this.xueli,
            major: this.zhuanyedaima,
            gradeRanking: this.xueye,
            preferredLocation: this.loveaddress,
            certificate: JSON.stringify(this.zhengshuList || []),
            internship: JSON.stringify(this.shixi || []),
            academic: chengji
          }
          fetch(`${this.BASE_URL1}/admin/resumes/saveResumes`, {
            method: 'post',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(resumes)
          })
            .then(res => res.json())
            .then(data => {
              // console.log("保存成功", data);
              if (data.code === 200) {
                this.selectResumes()
                this.isDisabled = true
                sessionStorage.setItem("xueyexinxi", "true")
                // 判断有没有做过测试
                this.ceshi()
              } else {
                alert("网络有波动，请稍后重试")
              }
            })
            .catch(error => {
              console.error("保存失败，原因是", error);
            })
        }
      }
    },
    ceshi() {
      fetch(`${this.BASE_URL2}/admin/career/result/selectUserId`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `userId=${this.userId}`,
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log(data.data);
          if (data.data === '暂无测试数据') {
            alert("保存成功,即将跳转职业测试页面")
            this.$router.push('/CareerQuiz');
          } else {
            alert("保存成功")
          }
        })
        .catch((error) => {
          console.error("查询失败，原因是", error);
        });
    },
    selectResumes() {
      // 根据userId 去查询所有信息
      fetch(`${this.BASE_URL1}/admin/resumes/selectResumes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `userId=${this.userId}`
      })
        .then(res => res.json())
        .then(data => {
          // console.log("基础学业数据", data);
          if (data.data === '暂无学业信息') {
            this.isDisabled = false
          } else {
            let resumes = data.data
            this.id = resumes.id
            this.ruxueshijian = resumes.admissionDate
            this.biyeshijian = resumes.graduationDate
            this.yuanxiao = resumes.almaMater
            this.xueli = resumes.degree
            this.zhuanye = resumes.major
            this.zhuanyedaima = resumes.major
            this.zhuanyes.forEach(category => {
              category.children.forEach(major => {
                if (major.label === this.zhuanye) {
                  this.zhuanye = major.value; // 单选模式直接赋值
                }
              });
            });
            this.loveaddress = resumes.preferredLocation
            this.xueye = resumes.gradeRanking
            if (resumes.certificate && JSON.parse(resumes.certificate).length > 0) {
              this.zhengshuList = JSON.parse(resumes.certificate);
            } else {
              this.zhengshuList = [""]
            }
            if (resumes.internship && JSON.parse(resumes.internship).length > 0) {
              this.shixi = JSON.parse(resumes.internship);
            } else {
              this.shixi = [""];
            }
            this.rows = JSON.parse(resumes.academic)
            const isFirstItemEmpty = (
              !this.rows[0] ||
              this.rows[0].subject === "" ||
              this.rows[0].score === ""
            );
            if (isFirstItemEmpty) {
              this.subject()
            }
            if (this.ruxueshijian === '' || this.biyeshijian === '' || this.yuanxiao === '' || this.xueli === '') {
              this.isDisabled = false
            } else {
              this.isDisabled = true
            }
          }
        })
        .catch(error => {
          console.error("查询失败2，原因是", error);
        });
    },
    selectSchool() {
      if (localStorage.getItem("allSchool")) {
        this.yuanxiaos = JSON.parse(localStorage.getItem("allSchool"))
      } else {
        fetch(`${this.BASE_URL}/admin/school/selectAllSchool`, {
          method: 'post'
        })
          .then(res => res.json())
          .then(data => {
            // console.log("所有学校", data);
            this.yuanxiaos = data.map(item => ({
              label: item.schoolName,
              yuanxiao: item.schoolName,
            }));
            localStorage.setItem("allSchool", JSON.stringify(this.yuanxiaos))
          })
          .catch(error => {
            console.error("查询学校失败，原因是", error);
          })
      }
    },
    handleChange(selectedValue) {
      // 1. 遍历 zhuanyes，找到匹配 selectedValue 的专业对象
      const selectedMajor = this.zhuanyes.flatMap(category =>
        category.children.find(major => major.value === selectedValue)
      ).find(Boolean);

      // 2. 如果找到，提取 label；否则设为空或默认值
      if (selectedMajor) {
        this.zhuanyedaima = selectedMajor.label
        // console.log("选中的专业名称:", selectedMajor.label);
        this.subject()
      }
    },
    addRow() {
      this.rows.push({ subject: '', score: '' })
    },
    removeRow() {
      if (this.rows.length > 0) {
        this.rows.pop()
      }
    }
  }
}
</script>

<style>
.el-input.is-disabled .el-input__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}

.el-textarea.is-disabled .el-textarea__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}

.el-date-editor.el-input__inner {
  width: 300px !important;
}

.el-cascader-menu__wrap {
  height: 400px !important;
}

.el-avatar,
.el-cascader-panel,
.el-radio,
.el-radio--medium.is-bordered .el-radio__label,
.el-radio__label {
  font-size: 16px !important;
}

@media (max-width: 768px) {
  .el-cascader-menu__wrap {
    margin-left: 10px;
  }
}
</style>

<style scoped>
.kuandu {
  width: 300px !important;
}

.xiugai {
  margin-top: 92px;
  margin-left: 25px;
}

.hengtiao1 {
  position: fixed;
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  z-index: 99;
}

.hengtiao {
  position: fixed;
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
  z-index: 99;
  margin-top: 8px;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.head01 {
  position: fixed;
  margin-top: 58px;
}

.pailie {
  display: flex;
}

.head02 {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: 50px;
}

.neirong {
  display: flex;
  justify-content: center;
  gap: 70px;
  margin-top: 80px;
  margin-left: 410px;
}

.jianju {
  margin-top: 15px;
}

.liebiao {
  display: flex;
}

.baocun {
  margin-top: 35px;
  display: flex;
  gap: 50px;
  margin-bottom: 50px;
  justify-content: center;
  align-items: center;
}

.span1 {
  margin-right: 7px;
  width: 130px;
  display: inline-block;
  text-align: right;
}

.chengjitable {
  margin-left: 138px;
  margin-top: 0px;
}

.span2 {
  margin-right: 7px;
  width: 100px;
  display: inline-block;
  margin-left: 30px;
  text-align: right;
}

button {
  margin-right: 10px;
  padding: 5px 10px;
  font-size: 16px;
  border: 1px solid #DCDFE6;
  background-color: white;
  cursor: pointer;
}

table {
  margin-top: 5px;
  width: 741px;
  border-collapse: collapse;
  border-color: #DCDFE6;
  border-radius: 4px;
}

th,
td {
  height: 40px;
  text-align: center;
}

input {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  border: none;
  font-size: 15px;
}

.save {
  background-color: #3572e5;
  height: 40px;
  width: 200px;
  border-radius: 10px;
  color: white;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.qvxiao {
  border: 3px solid #bfc3ce;
  color: #2e323d;
  height: 40px;
  width: 200px;
  border-radius: 10px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.input-group {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.delete-btn {
  margin-left: 10px;
  background-color: #d85353;
}

.add-btn {
  margin-top: 10px;
  background-color: #588cee;
  margin-left: 10px;
}

.gongzuoexp {
  margin-right: 10px;
  width: 741px;
}

@media (max-width: 768px) {
  .kuandu {
    width: 320px !important;
    margin-left: 10px;
  }

  .xiugai {
    margin-top: 0px;
    margin-left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hengtiao {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
    position: static;
    margin-top: 0px;
  }

  .gerenxinxi {
    margin-left: 20px;
  }

  .head01 {
    margin-top: 58px;
    width: auto;
  }

  .pailie {
    flex-direction: column;
    padding-top: 140px;
    width: 100%;
  }

  .head02 {
    margin-bottom: 50px;
  }

  .neirong {
    flex-direction: row;
    gap: 70px;
    margin-top: 0px;
    margin-left: 0px;
    padding: 0;
  }

  .jianju {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .liebiao {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .baocun {
    flex-direction: row;
    gap: 50px;
    margin-bottom: 50px;
  }

  .span1 {
    margin-right: 7px;
    width: 130px;
    display: inline-block;
    text-align: left;
    margin-bottom: 0;
    margin-left: 30px;
  }

  .chengjitable {
    margin-left: 10px;
    margin-top: 0px;
  }

  .span2 {
    margin-right: 7px;
    width: 130px;
    display: inline-block;
    margin-left: 30px;
    text-align: left;
    margin-bottom: 0;
  }

  button {
    margin-right: 10px;
    padding: 5px 10px;
    font-size: 16px;
  }

  table {
    width: 320px;
    min-width: auto;
    display: table;
  }

  th,
  td {
    height: 40px;
    font-size: 15px;
  }

  input {
    height: 40px;
    font-size: 15px;
  }

  .save {
    height: 40px;
    width: 200px;
  }

  .qvxiao {
    height: 40px;
    width: 200px;
  }

  .input-group {
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }

  .delete-btn {
    margin-left: 10px;
    margin-top: 0;
  }

  .add-btn {
    margin-left: 10px;
  }

  .gongzuoexp {
    margin-right: 0px;
    width: 320px;
    margin-left: 10px;
  }

  .logo {
    width: 50px;
  }

  .el-date-editor.el-input__inner {
    width: 320px !important;
    margin-left: 10px !important;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/personalInf.vue